import { render, staticRenderFns } from "./CustomerClone.vue?vue&type=template&id=c0eed0ae&scoped=true&"
import script from "./CustomerClone.vue?vue&type=script&lang=js&"
export * from "./CustomerClone.vue?vue&type=script&lang=js&"
import style0 from "./CustomerClone.vue?vue&type=style&index=0&id=c0eed0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eed0ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCardTitle,VContainer,VForm,VSelect})
